import type { MaintenanceStatus, MaintenanceType } from '@/modules/maintenance/types/maintenance';
import type { InventoryStatus } from '@/modules/inventory/types';

/** Sincroniza estado operativo del ítem según tarea activa (repair workflow). */
export function itemStatusForActiveMaintenance(
  type: MaintenanceType,
  status: MaintenanceStatus,
): InventoryStatus | null {
  if (status !== 'scheduled' && status !== 'in_progress') return null;
  switch (type) {
    case 'repair':
      return 'repair';
    case 'preventive':
    case 'cleaning':
      return 'maintenance';
    case 'inspection':
      return 'inspection';
    default:
      return 'maintenance';
  }
}

export function itemStatusAfterMaintenanceComplete(
  previousItemStatus: InventoryStatus,
): InventoryStatus {
  if (previousItemStatus === 'sold' || previousItemStatus === 'inactive') {
    return previousItemStatus;
  }
  return 'available';
}
